import Insight from "../insightClass";
import React from "react";
import { insight57Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight057 = new Insight(
  "22 July 2025",
  {
    pageTitle:
      "China 5th Floating Offshore Wind Conference Concludes Successfully in Wenzhou",
    metaDescription:
      "WeBridge Insights, China 5th Floating Offshore Wind Conference Concludes Successfully in Wenzhou",
    keyWords:
      "European Offshore Wind Market development, China 5th Floating Offshore Wind Conference Concludes Successfully in Wenzhou",
  },
  {
    src: insight57Media[3],
    alt: "offshore wind turbine",
  },
  "China 5th Floating Offshore Wind Conference Concludes Successfully in Wenzhou",
  "",
  `The winds of innovation swept through Wenzhou on 18–19 July 2025, as the China 5th Floating Offshore Wind Conference drew to a successful close. Against the backdrop of the surging East China Sea, this landmark event brought together leaders from government, industry, and academia to chart the next chapter in China’s floating wind journey. WeBridge’s partner Aaron Du was honoured to be invited, joining the conference and attending the Goldwind 16 MW+ floating turbine launch ceremony.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>
      China 5th Floating Offshore Wind Conference Concludes Successfully in
      Wenzhou
    </h1>
    <h2></h2>
    <p className="article-date">22 July 2025</p>
    <img src={insight57Media[0]} alt="Goldwind 16MW+ floating turbine" />
    <br />
    <p>
      The winds of innovation swept through Wenzhou on 18–19 July 2025, as the
      China 5th Floating Offshore Wind Conference drew to a successful close.
      Against the backdrop of the surging East China Sea, this landmark event
      brought together leaders from government, industry, and academia to chart
      the next chapter in China’s floating wind journey. WeBridge’s partner
      Aaron Du was honoured to be invited, joining the conference and attending
      the Goldwind 16 MW+ floating turbine launch ceremony.
    </p>
    <p>
      Jointly hosted by the National Wind Power Engineering Technology Research
      Centre and the Offshore Wind Power Branch of the China Ocean Engineering
      Consulting Association, and co-organised by Zhejiang Goldwind Technology,
      Shanghai Investigation, Design & Research Institute, CEEC Zhejiang
      Electric Power Design Institute, and Wenzhou Industrial and Energy
      Development Group, the conference showcased the full breadth of progress
      in floating offshore wind.
    </p>
    <p>
      From technical forums to strategic signings, the event served as a key
      platform for aligning policy, innovation, engineering, and
      investment—supporting the high-quality development of China’s floating
      offshore wind sector.
    </p>
    <img src={insight57Media[1]} alt="Goldwind 16MW+ floating turbine" />
    <h3>A Platform for Collaboration and Innovation</h3>
    <p>
      The opening ceremony on 19 July featured an address from Mr Zhai Endi,
      Secretary-General of the Offshore Wind Power Branch and Director of the
      National Wind Power Engineering Technology Research Centre. He highlighted
      the conference’s role in fostering integrated innovation across
      government, industry, academia, research, and application. Attendees were
      encouraged to explore new ideas and collaborate on strategies for
      advancing floating wind across multiple dimensions—from policy to deep-sea
      deployment.
    </p>
    <p>
      Key speeches were delivered by senior officials from the National Energy
      Administration, Wenzhou Municipal Government, Mr Cai Shaokuan (President
      of the Offshore Wind Power Branch), and Mr Cao Zhigang (Vice Chairman of
      Goldwind). They collectively reaffirmed floating wind’s strategic
      significance in China’s energy transition and underlined Wenzhou’s
      emerging role as a key industrial hub on the southeast coast.
    </p>
    <img src={insight57Media[2]} alt="Goldwind 16MW+ floating turbine" />
    <h3>Official launch of Goldwind’s 16+ MW floating wind turbine </h3>
    <p>
      Among the event’s highlights was the official launch of Goldwind’s latest
      innovation: a next-generation 16+ MW floating wind turbine, developed by
      Goldwind and manufactured locally in Wenzhou. This groundbreaking turbine,
      now ready for offshore deployment, breaks the foreign technology monopoly
      and firmly positions Wenzhou on the global map for cutting-edge floating
      wind technology.
    </p>
    <p>
      Its launch marks a pivotal moment—not only in China's industrial
      capability, but also in the country’s ability to independently develop,
      manufacture, and apply advanced floating offshore wind systems. With this
      achievement, Wenzhou has officially joined the ranks of global leaders in
      the research, engineering, and application of floating wind power.
    </p>
    <p>
      Additionally, the Zhejiang Centre of the National Wind Power Technology
      Innovation Centre was formally inaugurated at the event. The new centre is
      expected to play a central role in driving R&D, testing, and application
      of emerging floating wind technologies across the region and beyond.
    </p>
    <p>
      The conference also hosted a large-scale strategic signing ceremony,
      bringing together public and private sector stakeholders to accelerate
      deep-sea offshore wind collaboration. These agreements are set to enhance
      project pipelines, facilitate knowledge exchange, and promote industrial
      growth in far-sea wind power.
    </p>
    <img src={insight57Media[3]} alt="Goldwind 16MW+ floating turbine" />

    <h3>Technical Depth with Global Insight</h3>
    <p>
      Renowned experts from China and abroad delivered keynote presentations
      exploring cutting-edge topics such as:
    </p>
    <ul>
      <li>Fully coupled design of floating foundations</li>
      <li>Simulation technologies for deep-sea wind</li>
      <li>Integrated design and analysis of floating turbines</li>
      <li>Dynamic performance of marine structures</li>
      <li>The SATH floating wind concept</li>
    </ul>
    <p>
      These insights connected fundamental research with practical engineering,
      offering a complete innovation roadmap from concept to commercialisation.
    </p>
    <p>
      Two parallel technical forums—“Core Breakthroughs in Floating Wind” and
      “Integrated Development of Far-Sea Wind”—followed in the afternoon. Over
      20 leading scholars and engineers from turbine OEMs, design houses,
      universities, and certification bodies convened to tackle the sector’s
      most pressing challenges. Discussions centred on verification,
      standardisation, integrated design, and floating-specific O&M
      strategies—laying out feasible solutions to expand the development
      frontiers of offshore wind.
    </p>

    <h3>Five Years On, and Just Getting Started </h3>
    <p>
      Since its inception five years ago, the Floating Offshore Wind Conference
      has mirrored the growth of China’s far-sea wind sector—from early
      conceptual discussions to concrete industrial breakthroughs. The 2025
      edition reaffirmed China’s rising prominence in the global offshore wind
      landscape, underscored by Wenzhou’s emergence as a technological and
      manufacturing powerhouse in floating wind.
    </p>
    <p>
      As technology continues to evolve, and as collaboration across the value
      chain deepens, China’s floating offshore wind industry is set to play a
      vital role in the global energy transition. With local innovation, global
      vision, and increasing deployment readiness, the sector offers tremendous
      promise for contributing Chinese expertise and capability to the world's
      sustainable energy future.
    </p>
    <img src={insight57Media[4]} alt="Goldwind 16MW+ floating turbine" />

    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
